import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { HrReportScreen } from '@/features/hr-reports/report-screen'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/hr/reports/expense-ageing')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: ExpenseAgeingRoute,
})
function ExpenseAgeingRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <HrReportScreen
      report="expense-ageing"
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/expense-ageing', search: next })}
    />
  )
}
